<!-- 退款时等级计算规则 -->
<template>
  <div class="refund_rules global-content-flex">
    <div class="global-felx">
      <div class="box">
        <y-title label="退款时等级计算规则"></y-title>
        <div class="box_content">
          <el-radio-group
            v-model="ruleType"
            class="refund-rule-group"
          >
            <div class="rule-item">
              <el-radio :label="0">发生退款时，等级不重算</el-radio>
              <div class="rule-desc">
                <p>
                  订单确认收货后，基于有效交易的交易行为，计算等级指标。（若有退款成功，退款成功的订单金额将不被计算为等级计算指标。）
                </p>
                <p>若符合升级条件，则升级。若该笔订单发生退款，将不会触发重算等级。</p>
                <p>
                  当等级有效期到期时，系统将重新按照等级规则，计算有效交易的订单进行等级重算，并完成保级和降级。
                </p>
              </div>
            </div>
            <div class="rule-item">
              <el-radio :label="1"
                >发生退款时，回退至退款前等级，再重算等级</el-radio
              >
              <div class="rule-desc">
                <p>
                  发生退款时，系统按当前生效的等级升级规则重新计算等级，并与该退款单对应原订单确认收货前的会员等级进行比对处理：
                </p>
                <p>
                  1.若无法查询到确认收货前的会员等级，则直接采用重算后的等级及对应有效期。
                </p>
                <p>
                  2.若重算后等级高于确认收货前的等级，则取重算后的等级及对应有效期。
                </p>
                <p>
                  3.若重算后等级低于或等于确认收货前的等级，则沿用原订单确认收货前的历史等级及对应有效期；如该历史等级的有效期已过期，则按等级到期规则执行。
                </p>
                <p>注：选择该方案，会出现客户退款后，等级升级的情况</p>
              </div>
            </div>
            <div class="rule-item">
              <el-radio :label="2"
                >若发生退款时，按当前系统设置的等级规则重算等级，等级有效期按<span style="color: #007bff;">当前最新等级有效期</span>取值</el-radio
              >
              <div class="rule-desc">
                <p>
                  1.若重算后等级低于会员最新的等级，则降至重算后的等级。等级有效期按取值设置生效。
                </p>
                <p>
                  2.若重算后等级等于会员最新的等级，则等级不变。等级有效期按取值设置生效。
                </p>
                <p>3.若重算后等级高于会员最新的等级，则不变。等级有效期不变。</p>
              </div>
            </div>
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 让父级可以用 v-model 双向绑定退款规则类型
  model: {
    prop: "refundRuleType",
    event: "update:refundRuleType",
  },
  props: {
    refundRuleType: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    // 可写计算属性：get 取父级的值，set 通过事件回传
    ruleType: {
      get() {
        return this.refundRuleType;
      },
      set(val) {
        this.$emit("update:refundRuleType", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.refund_rules {
  height: 100%;
}
.box {
  width: 95%;
  margin-top: 30px;
  color: #333333;
  &:nth-child(1) {
    margin-top: 0px;
  }

  .box_header {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    width: fit-content;
    background: linear-gradient(to right, #f4f4f4, transparent);
    height: 30px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    &::before {
      content: "";
      display: inline-block;
      width: 3px;
      height: 16px;
      background: #1f4287;
      margin-left: 12px;
      margin-right: 5px;
    }
  }
  .box_content {
    margin-top: 16px;
  }

  .box_line {
    // border-bottom: 1px dashed #d0d0d0;
    // padding: 10px 20px;
    margin-top: 16px;
    &:nth-child(1) {
      margin-top: 0px;
    }

    > div:nth-of-type(1) {
      height: 14px;
    }

    .box_line_tips {
      font-size: 12px;
      background: #f6f7fa;
      display: inline-block;
      border-radius: 6px;
      margin-left: 18px;
      padding: 10px;
      padding-right: 40px;

      .tip_head {
        img {
          position: relative;
          top: 2px;
          margin-right: 5px;
        }
      }

      .tip_line {
        margin-left: 19px;
        margin-top: 6px;
      }

      .box_example {
        margin-left: -8px;
        margin-top: 20px;
        text-indent: 2em;
        line-height: 20px;
      }
    }
  }

  .box_line:nth-last-of-type(1) {
    border-bottom: none;
  }
}

// 退款时等级计算规则：三项单选 + 每项下方的多行说明
// 注意：element-ui 的 .el-radio-group 自带 font-size: 0，需显式恢复字号
.refund-rule-group {
  display: block;
  font-size: 14px;
  line-height: 22px;

  .rule-item {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .el-radio {
    display: flex;
    align-items: center;
    margin-right: 0;
    // 选项标题较长时需要换行，element-ui 默认 nowrap
    white-space: normal;
    line-height: 22px;

    /deep/ .el-radio__label {
      white-space: normal;
      line-height: 22px;
      color: #333333;
    }
  }

  .rule-desc {
    margin: 4px 0 0 22px;
    color: #999999;
    font-size: 14px;
    line-height: 22px;

    p {
      margin: 0;
    }
  }
}
</style>